export default __webpack_public_path__ + "static/media/Icon.9c379e71.png";